import $ from 'jquery';

class OpenTab {
    constructor(el) {
        this.DOM = {el: el};
        this.DOM.tabSelector = this.DOM.el.dataset.openTab;
        this.DOM.tab = document.querySelector(this.DOM.tabSelector);

        this.event = this.DOM.el.dataset.event || 'click';

        this.initEvents();
    }

    initEvents() {
        /* Add event listener */
        this.DOM.el.addEventListener(this.event, () => {
            $(this.DOM.tab).tab('show');
        });
    }
}

const tabNodes = Array.from(document.querySelectorAll('[data-open-tab]'));
if (tabNodes !== null) {
    tabNodes.forEach((tab) => { new OpenTab(tab); });
}
